import React, { useState } from "react";
import { Box, TextField, Button, CircularProgress } from "@mui/material";
import axios from "../../../config/axiosConfig";

// Estado 5 (Entregado) de una OT de Remplazo Equipos Vendidos Activos: mismo patrón que
// FinalizarReemplazoOT.jsx, salta directo de "Entregado" a "Finalizado" sin firma. Acá
// SÍ hay PDF dedicado (Nota de Reemplazo de Equipos Vendidos Activos) porque la Nota de
// Entrega genérica no muestra equipo en 'Vendido Activo' (su filtro de estados no lo
// incluye).
const FinalizarRemplazoVendidosActivosOT = ({ cod_ot, onFinalizado }) => {
  const [observacion, setObservacion] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const finalizar = async () => {
    if (!window.confirm("¿Finalizar este Remplazo? Quedará como Finalizado.")) return;
    setGuardando(true);
    setError("");

    const pdfWindow = window.open("", "_blank");
    if (pdfWindow) {
      pdfWindow.opener = null;
      pdfWindow.document.title = "Generando Nota de Reemplazo...";
      pdfWindow.document.body.innerHTML =
        '<div style="font-family:Arial,sans-serif;padding:24px;color:#334155">Finalizando y generando la Nota de Reemplazo...</div>';
    }

    try {
      const res = await axios.patch(`/api/ot-remplazo-vendidos-activos/finalizar/${cod_ot}`, { observacion });
      if (onFinalizado) onFinalizado(res.data);

      if (pdfWindow) {
        try {
          const { data } = await axios.get(`/api/ot-solicitudes/${cod_ot}/nota-remplazo-vendidos-activos.pdf`, { responseType: "blob" });
          const pdfUrl = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
          pdfWindow.location.replace(pdfUrl);
          setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
        } catch {
          pdfWindow.close();
        }
      }
    } catch (err) {
      if (pdfWindow) pdfWindow.close();
      setError(err?.response?.data?.error || "No se pudo finalizar el Remplazo.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      {error && <Box sx={{ color: "error.main", fontSize: 13, mb: 1.5 }}>{error}</Box>}
      <TextField
        label="Observación"
        fullWidth
        multiline
        rows={3}
        value={observacion}
        onChange={(e) => setObservacion(e.target.value)}
        sx={{ mb: 2 }}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" color="success" onClick={finalizar} disabled={guardando}>
          {guardando ? <CircularProgress size={20} color="inherit" /> : "Finalizar Remplazo"}
        </Button>
      </Box>
    </Box>
  );
};

export default FinalizarRemplazoVendidosActivosOT;
